<template>
  <div class="game" ref="game" v-bind:class="{ artworkVisible: artwork }">
    <header v-if="!this.$parent.$parent.artworkVisible" class="pt4 pb2">
      <h3>Level {{ this.getLevelDisplay() }}</h3>
      <h1>{{ grid.name }}</h1>
    </header>
    <div class="grid-wrapper">
      <div
        ref="grid"
        @mouseleave="mouseleave"
        class="grid-container"
        v-bind:class="{ imageVisible, grid: true, 'h-100': isInLine }"
        v-bind:style="{
          gridTemplateRows: `repeat(${rows}, ${size}px)`,
          gridTemplateColumns: `repeat(${cols}, ${size}px)`,
        }"
      >
        <Word
          class="word"
          v-for="(word, index) in grid.words"
          v-bind:key="`${word.hint}`"
          v-bind="word"
          v-bind:index="index"
        ></Word>
        <Cell
          v-for="cell in grid.cells"
          v-bind:key="`${cell.row}-${cell.col}`"
          v-bind:col="cell.col"
          v-bind:row="cell.row"
          v-bind:words="cell.words"
          v-bind:status="cell.status"
          v-bind:value="cell.value"
          v-bind:thumbUrl="cell.thumbUrl"
          v-on:cell:changed="cellChanged"
          v-on:cell:selected="cellSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Cell from "./Cell";
// import grid from "../grid";
import Word from "./Word";

export default {
  mounted: function() {
    console.log('grid, isInLine=', this.isInLine);
    this.$root.$on("image:placed", () => {
      this.imageVisible = false;
      this.backgroundImage = this.gridImage;
    });
    this.$root.$on("level:changed", () => {
      this.setCellSize();
    });

    this.setCellSize();
    window.onresize = () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.setCellSize();
      }, 200);
    };
  },
  inject: ["getLevelDisplay"],
  methods: {
    setCellSize: function() {
      this.size = 0;
      setTimeout(() => {
        if (!this.$refs.game) {
          return;
        }
        const { height: gameHeight } = this.$refs.game.getBoundingClientRect();
        const { height: headerHeight } = this.$el
          .querySelector("header")
          .getBoundingClientRect();
        const availableHeight = gameHeight - headerHeight - 112 - 40;
        let availableWidth = window.innerWidth;
        if (
          window.matchMedia(
            "(orientation: landscape) and (hover: none) and (pointer: coarse)"
          ).matches
        ) {
          const { width: headerWidth } = this.$el
            .querySelector("header")
            .getBoundingClientRect();
          availableWidth = window.innerWidth - headerWidth * 2;
        }
        if (
          window.matchMedia("(hover: none) and (pointer: coarse)").matches ||
          window.matchMedia("screen and (max-width: 850px)").matches
        ) {
          // also calculate cell size based on available height
          const maxCellWidth =
            (availableWidth - (this.grid.rows * 12 + 24)) / this.grid.rows;
          // availableHeight
          const availableHeightOnMobile = window.innerHeight - headerHeight - 112 - 64;
          const maxCellHeight = availableHeightOnMobile / this.grid.cols;
          const cellSize = Math.min(maxCellWidth, maxCellHeight);
          console.log('maxCellHeihgt=', maxCellHeight, this.grid);
          console.log('availableHeightOnMobile', availableHeightOnMobile)
          console.log('availableHeight=', availableHeight)
          console.log('cellSize', cellSize)
          this.size = Math.max(Math.min(cellSize, 90), 40);
        } else {
          const cellSize = availableHeight / this.grid.rows;
          console.log('cellSize', cellSize)
          this.size = Math.max(Math.min(cellSize, 200), 60);
        }
        console.log('this.size is now =', this.size);
        this.$forceUpdate();
      }, 100);
    },
    mouseleave: function() {
      this.$root.$emit("cells:deselect_all");
      this.$root.$emit("words:deselect");
    },
    getCell: function({ row, col }) {
      return this.grid.cells.find((c) => c.row === row && c.col === col);
    },
    cellSelected: function({ row, col }) {
      this.currentCell = { row, col };
    },
    cellChanged: function({ row, col, img, thumbUrl }) {
      this.$root.$emit("cell:changed", { row, col, img, thumbUrl });
      this.$root.$emit("grid:changed", this.grid);
    },
  },
  beforeDestroy: function() {
    this.$root.$off("cell:emptied");
    this.$root.$off("image:placed");
    this.$root.$off("grid:fix");
  },
  created: function() {
    this.$root.$on("cell:emptied", ({ row, col }) => {
      const cell = this.grid.cells.find((c) => c.row === row && c.col === col);
      cell.value = "";
      cell.isValid = false;
    });

    this.$root.$on("image:placed", () => {
      this.currentCell = null;
    });

    this.$root.$on("grid:fix", () => {
      const invalids = this.grid.cells.filter((c) => !c.isValid && c.value);

      invalids.map((c) => {
        this.$root.$emit("cell:changed", {
          row: c.row,
          col: c.col,
          img: undefined,
        });
      });
      console.log("emit show!");
      this.$root.$emit("image:show", null, false);
      this.$root.$emit("grid:fixed", null, false);
    });
  },
  components: {
    Cell,
    Word,
  },
  data: function() {
    return {
      size: 0,
      currentCell: null,
      imageVisible: false,
      timer: null,
    };
  },
  props: {
    artwork: Object,
    grid: Object,
    originalGrid: Object,
    cellSize: Number,
    height: Number,
    isInLine: Boolean,
  },
  computed: {
    rows: function() {
      return this.grid.rows;
    },
    cols: function() {
      return this.grid.cols;
    },
  },
};
</script>

<style scoped>
header {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 100;
  background-color: white;
}

header h3 {
  margin: 0;
  position: relative;
  z-index: 1;
  color: #bbb;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

header h1 {
  margin: 0;
  position: relative;
  z-index: 1;
  color: #3c4043;
  font-size: 24px;
  font-weight: 500;
}

.game {
  display: flex;
  justify-content: center;
}

.grid-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100% + 60px);
}

.grid-container {
  font-size: 3rem;
  justify-content: center;
  width: 100%;
  /* overflow:scroll; */
  padding: 148px 12px 40px 12px;
  padding-bottom: 40px !important;
  display: grid;
  grid-gap: 12px;
}

@media screen and (hover: none) and (pointer: coarse) {
  .grid-container {
    padding: 148px 12px 40px 12px;
  }
}

.imageVisible.grid {
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: visible;
}

.imageVisible.grid > div {
  display: none;
}

.level-infos {
  color: #669df6;
}

@media screen and (max-width: 1000px) {
  /* .artworkVisible {
    display: none;
  } */
}

.game {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 1000px) {
  .level-infos span + span {
    display: none;
  }
}

@media (orientation: landscape) and (hover: none) and (pointer: coarse) {
  header {
    align-items: start;
    width: auto;
    text-align: left;
    align-items: start;
    margin-left: 24px;
    background-color: transparent;
    max-width: 20%;
  }

  .grid {
    padding: 24px 12px;
  }
}
</style>
